import clsx from 'clsx';
import React, { HTMLAttributes } from 'react';
import JsonRTE from '../../basic/jsonRTE';

interface CardHeaderProps extends HTMLAttributes<HTMLHeadElement> {
  className?: string;
  header?: any;
}

const CardHeader = ({ className, header, ...props }: CardHeaderProps): JSX.Element => {
  if (!header) return <></>;
  return (
    <h2 className={clsx('text-card-header', className)} {...props}>
      {typeof header === 'string' ? header : <JsonRTE json={header} />}
    </h2>
  );
};

export default CardHeader;
